module.exports = __webpack_public_path__ + "img/t-rize.2c88a3c4.svg";